const debounce = (fn, timeout = 100) => {
  let clearId = null;
  return (...args) => {
    clearId && clearTimeout(clearId);
    clearId = setTimeout(() => fn(...args), timeout);
  };
};

export default debounce;
